module.exports = __webpack_public_path__ + "img/fig17.9e543709.jpg";